"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventControllerApi = exports.EventControllerApiFactory = exports.EventControllerApiFp = exports.EventControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * EventControllerApi - axios parameter creator
 * @export
 */
const EventControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CancelEvent} cancelEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsCancelPost: (cancelEvent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cancelEvent' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsCancelPost', 'cancelEvent', cancelEvent);
            const localVarPath = `/api/events/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cancelEvent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [userId]
         * @param {boolean} [withEventUsers]
         * @param {boolean} [withEventLocation]
         * @param {boolean} [allEvents]
         * @param {boolean} [onlyFutureEvents]
         * @param {boolean} [archived]
         * @param {boolean} [pastOnly]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [publicOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsGet: (userId, withEventUsers, withEventLocation, allEvents, onlyFutureEvents, archived, pastOnly, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, publicOnly, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (withEventUsers !== undefined) {
                localVarQueryParameter['withEventUsers'] = withEventUsers;
            }
            if (withEventLocation !== undefined) {
                localVarQueryParameter['withEventLocation'] = withEventLocation;
            }
            if (allEvents !== undefined) {
                localVarQueryParameter['allEvents'] = allEvents;
            }
            if (onlyFutureEvents !== undefined) {
                localVarQueryParameter['onlyFutureEvents'] = onlyFutureEvents;
            }
            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }
            if (pastOnly !== undefined) {
                localVarQueryParameter['pastOnly'] = pastOnly;
            }
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (publicOnly !== undefined) {
                localVarQueryParameter['PublicOnly'] = publicOnly;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsIdDelete', 'id', id);
            const localVarPath = `/api/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsIdGet', 'id', id);
            const localVarPath = `/api/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdImagePut: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsIdImagePut', 'id', id);
            const localVarPath = `/api/events/{id}/Image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {Event} event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdPut: (id, event, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsIdPut', 'id', id);
            // verify required parameter 'event' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsIdPut', 'event', event);
            const localVarPath = `/api/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(event, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} qrCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdQrCodeQrCodePut: (id, qrCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsIdQrCodeQrCodePut', 'id', id);
            // verify required parameter 'qrCode' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsIdQrCodeQrCodePut', 'qrCode', qrCode);
            const localVarPath = `/api/events/{id}/qrCode/{qrCode}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"qrCode"}}`, encodeURIComponent(String(qrCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsNotLinkedGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/events/notLinked`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Event} event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsPost: (event, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'event' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsPost', 'event', event);
            const localVarPath = `/api/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(event, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RescheduleEvent} rescheduleEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsReschedulePost: (rescheduleEvent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rescheduleEvent' is not null or undefined
            (0, common_1.assertParamExists)('apiEventsReschedulePost', 'rescheduleEvent', rescheduleEvent);
            const localVarPath = `/api/events/reschedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rescheduleEvent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EventControllerApiAxiosParamCreator = EventControllerApiAxiosParamCreator;
/**
 * EventControllerApi - functional programming interface
 * @export
 */
const EventControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EventControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CancelEvent} cancelEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsCancelPost(cancelEvent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsCancelPost(cancelEvent, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [userId]
         * @param {boolean} [withEventUsers]
         * @param {boolean} [withEventLocation]
         * @param {boolean} [allEvents]
         * @param {boolean} [onlyFutureEvents]
         * @param {boolean} [archived]
         * @param {boolean} [pastOnly]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [publicOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsGet(userId, withEventUsers, withEventLocation, allEvents, onlyFutureEvents, archived, pastOnly, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, publicOnly, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsGet(userId, withEventUsers, withEventLocation, allEvents, onlyFutureEvents, archived, pastOnly, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, publicOnly, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdImagePut(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsIdImagePut(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {Event} event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdPut(id, event, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsIdPut(id, event, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} qrCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdQrCodeQrCodePut(id, qrCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsIdQrCodeQrCodePut(id, qrCode, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsNotLinkedGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsNotLinkedGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Event} event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsPost(event, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsPost(event, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RescheduleEvent} rescheduleEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsReschedulePost(rescheduleEvent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventsReschedulePost(rescheduleEvent, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.EventControllerApiFp = EventControllerApiFp;
/**
 * EventControllerApi - factory interface
 * @export
 */
const EventControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EventControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {CancelEvent} cancelEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsCancelPost(cancelEvent, options) {
            return localVarFp.apiEventsCancelPost(cancelEvent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [userId]
         * @param {boolean} [withEventUsers]
         * @param {boolean} [withEventLocation]
         * @param {boolean} [allEvents]
         * @param {boolean} [onlyFutureEvents]
         * @param {boolean} [archived]
         * @param {boolean} [pastOnly]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [publicOnly]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsGet(userId, withEventUsers, withEventLocation, allEvents, onlyFutureEvents, archived, pastOnly, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, publicOnly, options) {
            return localVarFp.apiEventsGet(userId, withEventUsers, withEventLocation, allEvents, onlyFutureEvents, archived, pastOnly, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, publicOnly, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdDelete(id, options) {
            return localVarFp.apiEventsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdGet(id, options) {
            return localVarFp.apiEventsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdImagePut(id, options) {
            return localVarFp.apiEventsIdImagePut(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {Event} event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdPut(id, event, options) {
            return localVarFp.apiEventsIdPut(id, event, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {string} qrCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsIdQrCodeQrCodePut(id, qrCode, options) {
            return localVarFp.apiEventsIdQrCodeQrCodePut(id, qrCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsNotLinkedGet(options) {
            return localVarFp.apiEventsNotLinkedGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Event} event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsPost(event, options) {
            return localVarFp.apiEventsPost(event, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RescheduleEvent} rescheduleEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventsReschedulePost(rescheduleEvent, options) {
            return localVarFp.apiEventsReschedulePost(rescheduleEvent, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EventControllerApiFactory = EventControllerApiFactory;
/**
 * EventControllerApi - object-oriented interface
 * @export
 * @class EventControllerApi
 * @extends {BaseAPI}
 */
class EventControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {CancelEvent} cancelEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsCancelPost(cancelEvent, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsCancelPost(cancelEvent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [userId]
     * @param {boolean} [withEventUsers]
     * @param {boolean} [withEventLocation]
     * @param {boolean} [allEvents]
     * @param {boolean} [onlyFutureEvents]
     * @param {boolean} [archived]
     * @param {boolean} [pastOnly]
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {number} [pageSize]
     * @param {number} [pageNumber]
     * @param {string} [sortBy]
     * @param {string} [sortOrder]
     * @param {boolean} [publicOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsGet(userId, withEventUsers, withEventLocation, allEvents, onlyFutureEvents, archived, pastOnly, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, publicOnly, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsGet(userId, withEventUsers, withEventLocation, allEvents, onlyFutureEvents, archived, pastOnly, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, publicOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsIdDelete(id, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsIdGet(id, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsIdImagePut(id, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsIdImagePut(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {Event} event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsIdPut(id, event, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsIdPut(id, event, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {string} qrCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsIdQrCodeQrCodePut(id, qrCode, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsIdQrCodeQrCodePut(id, qrCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsNotLinkedGet(options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsNotLinkedGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Event} event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsPost(event, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsPost(event, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RescheduleEvent} rescheduleEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventControllerApi
     */
    apiEventsReschedulePost(rescheduleEvent, options) {
        return (0, exports.EventControllerApiFp)(this.configuration).apiEventsReschedulePost(rescheduleEvent, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EventControllerApi = EventControllerApi;
